export default {
  eyebrow:        "scraper · fonds de commerce",
  title:          "Annonces",
  refresh:        "Actualiser",
  export:         "Exporter CSV",
  filters:        "Filtres",
  results:        (n) => `${n} résultat${n !== 1 ? "s" : ""}`,
  filtered:       "filtré",
  page:           (p, t) => `page ${p}/${t}`,
  loading:        "Chargement…",
  errorLoad:      "Impossible de charger les annonces",

  filterTitle:    "Filtres",
  reset:          "Réinitialiser",
  search:         "Recherche",
  searchPlaceholder: "Titre, région, ville…",
  source:         "Source",
  allSources:     "Toutes les sources",
  sort:           "Tri",
  sortDate:       "Plus récent",
  sortPriceAsc:   "Prix croissant",
  sortPriceDesc:  "Prix décroissant",
  price:          "Prix",
  seeResults:     "Voir les résultats",

  colTitle:       "Titre",
  colPrice:       "Prix",
  colLocation:    "Localisation",
  colSource:      "Source",
  colDate:        "Date",
  noListings:     "Aucune annonce trouvée",
  seeAd:          "Voir l'annonce",
  description:    "Description",
  region:         "Région",
  department:     "Département",
  address:        "Adresse",

  statTotal:      "Total",
  statAvgPrice:   "Prix moyen",
  statMaxPrice:   "Prix max",
  ann:            "ann.",

  badgeNew:       "Nouveau",
  badgeRecent:    "Récent",

  navListings:    "Annonces",
  navStats:       "Statistiques",
  navFavorites:   "Mes favoris",
  navSettings:    "Paramètres",

  emptyTitle:     "Aucun résultat",
  emptySubtitle:  "Aucune annonce ne correspond à vos filtres.",
  emptyReset:     "Réinitialiser les filtres",

  statWithPrice:  "Avec prix",
  statAnn:        "ann.",
  statLast7:      "cette semaine",
  statLast30:     "ce mois",
  statBySrc:      "Par source",
  statSrcShare:   "Répartition des sources",
  statPriceDist:  "Distribution des prix",
  statByRegion:   "Top régions",
  statByDep:      "Top départements",
  statTimeline:   "Annonces scrappées (30 derniers jours)",

  authLoginTitle:   "Connexion",
  authRegisterTitle:"Créer un compte",
  authFirstName:    "Prénom",
  authLastName:     "Nom",
  authGender:       "Genre",
  authGenderM:      "Homme",
  authGenderF:      "Femme",
  authRequired:     "Champs obligatoires",
  authEmail:        "Email",
  authPassword:         "Mot de passe",
  authConfirmPassword:  "Confirmer le mot de passe",
  authPasswordMismatch: "Les mots de passe ne correspondent pas",
  authLogin:        "Se connecter",
  authCreateAccount:"Créer un compte",
  authRegister:     "S'inscrire",
  authNoAccount:    "Pas encore de compte ?",
  authHasAccount:   "Déjà un compte ?",
  authLoading:      "Chargement…",
  authError:        "Une erreur est survenue",
  authLogout:           "Déconnexion",
  authContinueWithout:  "Continuer sans compte →",
  authCheckEmail:       "Vérifiez vos emails",
  authCheckEmailSub:    "Un lien de confirmation a été envoyé à",
  authResend:           "Renvoyer l'email de confirmation",
  authResending:        "Envoi en cours…",
  authResent:           "Email renvoyé !",
  authNotVerified:      "Compte non vérifié.",
  authVerifying:        "Vérification en cours…",
  authVerified:         "Compte activé !",
  authVerifiedSub:      "Vous allez être redirigé automatiquement.",

  favEmptyTitle:    "Aucun favori",
  favEmptySubtitle: "Ajoutez des annonces en cliquant sur le ♡",

  navAlerts:            "Mes alertes",
  navProfile:           "Mon profil",
  alertsTitle:          "Mes alertes",
  alertsEmpty:          "Aucune alerte configurée",
  alertsEmptySub:       "Créez une alerte pour être notifié par email lors de nouvelles annonces.",
  alertNew:             "Nouvelle alerte",
  alertName:            "Nom de l'alerte",
  alertKeywords:        "Mots-clés",
  alertKeywordsPlaceholder: "Ex : tabac, bar, FDJ…",
  alertSource:          "Source",
  alertAllSources:      "Toutes les sources",
  alertPriceMin:        "Prix min (€)",
  alertPriceMax:        "Prix max (€)",
  alertRegion:          "Région",
  alertRegionPlaceholder: "Ex : Île-de-France",
  alertCreate:          "Créer l'alerte",
  alertCreating:        "Création…",
  alertDelete:          "Supprimer",
  alertActive:          "Active",
  alertInactive:        "Inactive",
  alertCriteria:        "Critères",
  alertNoCriteria:      "Toutes les annonces",
  profileTitle:         "Mon profil",
  profileInfo:          "Informations",
  profileSave:          "Enregistrer",
  profileSaved:         "Modifications enregistrées",
  profilePassword:      "Changer le mot de passe",
  profileCurrentPwd:    "Mot de passe actuel",
  profileNewPwd:        "Nouveau mot de passe",
  profileConfirmPwd:    "Confirmer le nouveau mot de passe",
  profilePwdUpdated:    "Mot de passe mis à jour",
  profileDanger:        "Zone de danger",
  profileDeleteAccount: "Supprimer mon compte",
  profileDeleteConfirm: "Confirmez votre mot de passe pour supprimer définitivement votre compte.",
  profileDeleting:      "Suppression…",
  profileSaving:        "Enregistrement…",
  profileUpdating:      "Mise à jour…",
};
